export const graphqlErrorToString = (error: any) => {
  if (!error) return null;
  if (error.graphQLErrors && error.graphQLErrors.message)
    return error.graphQLErrors.message;
  if (error.graphQLErrors && error.graphQLErrors.length > 0)
    return error.graphQLErrors[0].message;

  return error.message;
};
